import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { StoreComponentDef } from '@df/catalog-ui/store/store.component.def';
import { DfImageDirective } from '@df/module-image/df-image.directive';

declare module '@df/catalog/store/store' {
    export interface IStoreDataV1 {
        images?: string[];
    }
}

@Component({
    selector: 'store-link',
    templateUrl: './store-link.component.html',
    standalone: true,
    imports: [DfImageDirective, RouterModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class StoreLinkComponent extends StoreComponentDef {}
